import { Component, OnInit } from '@angular/core';
import { ReportBugService } from '../../../core-frontend-common/components/report-bug/report-bug.service';
import { ReportBugModel } from '../../../core-frontend-common/components/report-bug/report-bug.model';
import { BaseModalDialogService } from '../../components/dialog/base-modal-dialog.service';
import { AppCommunicationService } from '../../services/app-communication.service';
import { createSubQuery } from '../../../core-frontend-common/misc/query-designer/query-designer-functions';
import { queryFilterTypes, queryOperators } from '../../../core-frontend-common/misc/query-designer/query-designer';

@Component({
  selector: 'smart-error-reports-view',
  templateUrl: './error-reports-view.component.html',
  styleUrls: ['./error-reports-view.component.scss'],
})
export class ErrorReportsViewComponent implements OnInit {
  solvedReports: ReportBugModel[] = [];

  notSolvedReports: ReportBugModel[] = [];

  loading = false;

  pTableSolved = {
    search: '',
    page: 1,
    pageSize: 5,
    totalItems: 1,
    loading: false,
  };

  pTableNotSolved = {
    search: '',
    page: 1,
    pageSize: 5,
    totalItems: 1,
    loading: false,
  };

  isLoadingDetails = false;

  fullReport: ReportBugModel;

  constructor(
    protected reportBugService: ReportBugService,
    protected modalService: BaseModalDialogService,
    protected appCommunicationService: AppCommunicationService,
  ) {
  }

  ngOnInit() {
    this.refreshNotSolvedData();

    this.refreshSolvedData();
  }

  setPageSolved(pageInfo) {
    this.pTableSolved.page = (pageInfo.first + pageInfo.rows) / this.pTableSolved.pageSize;
    this.refreshSolvedData();
  }

  setPageNotSolved(pageInfo) {
    this.pTableNotSolved.page = (pageInfo.first + pageInfo.rows) / this.pTableNotSolved.pageSize;
    this.refreshNotSolvedData();
  }

  refreshSolvedData() {
    this.pTableSolved.loading = true;

    const query = {
      isSolved: {},
    };

    query.isSolved = createSubQuery(queryOperators.OR, [true], 'isSolved', queryFilterTypes.EQUAL);

    const queryDesigner = {
      search: [],
      where: {
        operatorType: 'AND',
        operands: [],
      },
      page: this.pTableSolved.page,
      pageSize: this.pTableSolved.pageSize,
      orderBy: [
        {
          field: 'Id',
          order: 'DESC',
        },
      ],
    };
    Object.keys(query)
      .forEach(queryItem => {
        if (Object.keys(query[queryItem]).length > 0 && queryItem !== 'search') {
          queryDesigner.where.operands.push(query[queryItem]);
        }
      });

    this.reportBugService.getAll(queryDesigner)
      .subscribe(v => {
        const reports = v.items;
        this.pTableSolved.totalItems = v.totalItems;
        this.solvedReports = reports;
        this.pTableSolved.loading = false;
      }, e => {
        console.log(e);
        this.pTableSolved.loading = false;
      });
  }

  refreshNotSolvedData() {
    this.pTableNotSolved.loading = true;

    const query = {
      isSolved: {},
    };

    query.isSolved = createSubQuery(queryOperators.OR, [false], 'isSolved', queryFilterTypes.EQUAL);

    const queryDesigner = {
      search: [],
      where: {
        operatorType: 'AND',
        operands: [],
      },
      page: this.pTableNotSolved.page,
      pageSize: this.pTableNotSolved.pageSize,
      orderBy: [
        {
          field: 'Id',
          order: 'DESC',
        },
      ],
    };
    Object.keys(query)
      .forEach(queryItem => {
        if (Object.keys(query[queryItem]).length > 0 && queryItem !== 'search') {
          queryDesigner.where.operands.push(query[queryItem]);
        }
      });

    this.reportBugService.getAll(queryDesigner)
      .subscribe(v => {
        const reports = v.items;
        this.pTableNotSolved.totalItems = v.totalItems;
        this.notSolvedReports = reports;
        this.pTableNotSolved.loading = false;
      }, e => {
        console.log(e);
        this.pTableNotSolved.loading = false;
      });
  }

  detailClicked(id: number) {
    if (this.fullReport && this.fullReport.id === id) {
      return;
    }

    this.isLoadingDetails = true;

    this.reportBugService
      .getById(id)
      .subscribe(v => {
        this.isLoadingDetails = false;
        this.fullReport = v;
        this.fullReport.techData = JSON.parse(v.techData);
      }, e => {
        this.isLoadingDetails = false;
      });
  }

  openImage(imageUrl: string) {
    const title = 'Náhľad obrazovky';
    const content = `
      <img src="${imageUrl}" />
    `;
    this.modalService
      .openDialog({ title, content, buttons: null }, 'report-bug-image-view');
  }

  solveChangeReport(report: ReportBugModel) {
    this.appCommunicationService.loadingOn('Idem, riešim.');
    this.reportBugService
      .setSolved(report.id)
      .subscribe(v => {
        this.refreshNotSolvedData();
        this.refreshSolvedData();
        this.appCommunicationService.loadingOff();
      }, e => {
        console.log(e);
        this.appCommunicationService.loadingOff();
      });
  }

}
